module.exports = __webpack_public_path__ + "img/minority_owned_business.d0c6a7b9.svg";